import React from 'react';
import { motion } from 'framer-motion';
import './Header.css';

const Header: React.FC = () => {
  return (
    <motion.header 
      className="header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="header-container">
        <div className="logo">
          <span className="logo-text">Spatiocytic</span>
        </div>
        <nav className="nav">
          <a href="#about" className="nav-link">About</a>
          <a href="#technology" className="nav-link">Technology</a>
          <a href="#team" className="nav-link">Team</a>
          <a href="#contact" className="nav-link">Contact</a>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;